import { render, staticRenderFns } from "./s5-2.vue?vue&type=template&id=16676619&scoped=true&"
import script from "./s5-2.vue?vue&type=script&lang=js&"
export * from "./s5-2.vue?vue&type=script&lang=js&"
import style0 from "./s5-2.vue?vue&type=style&index=0&id=16676619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16676619",
  null
  
)

export default component.exports